let address3 = 'https://api.minderworks.com/';
let api = address3 + 'hzwmj/person-message';

export default {
  savePersonMsg: api + '/savePersonMessage',
};
